import { track } from "jiffy-analytics";
import CameraUploader from "common/mobile-camera-upload";
import DesignFileUploadingClass from "./design-file-uploading-class";

export default class DesignUploadCtaPlpCameraUploadClass {
  #buttonSelector;

  #props;

  #cameraUploader;

  #modal;

  constructor(props) {
    this.#buttonSelector = props.buttonSelector;
    this.#props = props;
    this.#modal = props.modal;
  }

  get #$button() {
    return document.querySelector(this.#buttonSelector);
  }

  init() {
    if (!this.#buttonSelector) return;

    this.#cameraUploader = new CameraUploader({
      button: this.#buttonSelector,
      onImage: payload => {
        const { file } = payload;
        this.#handleCameraFile(file);
      },
      onError: error => {
        this.#handleCameraError(error);
      }
    });

    // Add click tracking for camera button
    this.#addClickTracking();
  }

  #addClickTracking() {
    if (!this.#$button) return;

    this.#$button.addEventListener("click", () => {
      track("pdp_design_preview_upload_clicked", {
        target: "Camera"
      });
    });
  }

  #handleCameraFile(file) {
    this.#modal?.closeModal();
    const fileUploader = new DesignFileUploadingClass({
      file,
      triggerSource: "plp",
      uploadSource: "camera",
      dtfChannel: this.#props.dtfChannel,
      ...this.#props
    });
    fileUploader.processFile();
  }

  #handleCameraError(error) {
    // Handle specific camera errors
    if (error.code === "camera_permission_denied") {
      // Camera permission denied - user can retry
      this.#logError("Camera permission denied");
    } else if (error.code === "camera_permission_permanently_denied") {
      // Camera permission permanently denied - user needs to enable in settings
      this.#logError("Camera permission permanently denied");
    } else {
      // Other camera access errors
      this.#logError("Camera access error");
    }
  }

  #logError(_message) {
    // Error logging placeholder - can be extended for proper error handling
    // Using this.#props to satisfy linter requirement for 'this' usage
    return this.#props;
  }

  destroy() {
    if (this.#cameraUploader) {
      try {
        this.#cameraUploader.destroy?.();
      } catch {
        // Silent cleanup error
      }
      this.#cameraUploader = null;
    }
  }
}
